export const Roles = {
  Admin: "Admin",
  Leader: "Leader",
  Manager: "Manager"
};

export const GetRoles = () => {
  var roles = [];
  for (var key in Roles) {
    roles.push(Roles[key]);
  }

  return roles;
};
